import type { EntityResponse } from '~/@types'
import { AppApi } from '~/App/utils/api'
import { API_URL } from '~/constants/environment'

import type { AddCartItemPayload, Cart, PublishCartPayload } from './@types'

const cart = new AppApi(API_URL, 'customers/cart')

export const addCartItem = async (data: AddCartItemPayload) => {
  const response = await cart.post<EntityResponse<Cart>>({
    path: 'items',
    body: { data },
  })
  return response.data
}

export const publishCart = async (data: PublishCartPayload) => {
  await cart.post({
    path: 'publish',
    body: { data },
  })
}
